var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpsetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#864e20}"))), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 7.656,
    style: {
      fill: "#f8de40"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.055 7.313A1.747 1.747 0 1 0 8.8 9.059a1.747 1.747 0 0 0-1.745-1.746zM16.958 7.313A1.747 1.747 0 1 0 18.7 9.059a1.747 1.747 0 0 0-1.742-1.746z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 13.938a14.69 14.69 0 0 1-12.406 6.531c-5.542 0-6.563-1-9.142-2.529A7.66 7.66 0 0 0 8.656 23h6.688A7.656 7.656 0 0 0 23 15.344z",
    style: {
      fill: "#e7c930"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.1 13.157a10.752 10.752 0 0 0-.291-1.243 6.685 6.685 0 0 0-.489-1.22 3.624 3.624 0 0 0-.872-1.109 2.354 2.354 0 0 0-.669-.386 2.217 2.217 0 0 0-1.548 0 2.423 2.423 0 0 0-.67.386 3.636 3.636 0 0 0-.872 1.109 6.728 6.728 0 0 0-.49 1.221 10.575 10.575 0 0 0-.29 1.242 16.869 16.869 0 0 0-.228 2.5c0 .438 0 .874.021 1.31a.133.133 0 0 0 .265.012c.062-.428.128-.853.2-1.276.133-.8.3-1.6.507-2.372a9.171 9.171 0 0 1 .84-2.171 2.8 2.8 0 0 1 .661-.8 1.3 1.3 0 0 1 1.654 0 2.812 2.812 0 0 1 .662.8 9.207 9.207 0 0 1 .841 2.172c.206.773.373 1.568.506 2.372.075.421.14.843.2 1.268a.133.133 0 0 0 .264-.012c.021-.433.025-.867.02-1.3a16.979 16.979 0 0 0-.222-2.503z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsetIcon);
export default __webpack_public_path__ + "static/media/upset-icon.4592edc39308417d3c74e2520bd1965a.svg";
export { ForwardRef as ReactComponent };